export const ITEM_DIMENSIONS = {
  WIDTH: '140px',
  HEIGHT: '34px'
};
